import { render, staticRenderFns } from "./ListFornecedores.vue?vue&type=template&id=39cdf97d"
import script from "./ListFornecedores.vue?vue&type=script&lang=js"
export * from "./ListFornecedores.vue?vue&type=script&lang=js"
import style0 from "./ListFornecedores.vue?vue&type=style&index=0&id=39cdf97d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports